import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	anonymous: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	anonymous: {
		id: 'native-issue-table.common.issue-cells.user.anonymous',
		defaultMessage: 'Anonymous',
		description: 'String to display when a user is not defined',
	},
});
export default messages;
